import Link from 'next/link';
import { ElementType, FC, ReactNode, SyntheticEvent } from 'react';
import { useTranslation } from 'utils/i18n';

import Spinner from '../shared/spinner';

interface Props {
  children?: ReactNode;
  label?: string;
  disabled?: boolean;
  component?: ElementType;
  conflictComponent?: FC;
  conflict?: boolean;
  onClick?: () => unknown;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  'data-testid'?: string;
}

const AddToBasketConflict: FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="quick-book__clash-alert">
      <p className="quick-book__clash-alert-text">
        {t('quick_book.timeslot_widget.conflict_warning')}
      </p>
      <Link
        href={t('navigation.advanced_booking.url')}
        className="button button--secondary button--block"
      >
        {t('quick_book.go_to_advanced_booking')}
      </Link>
    </div>
  );
};

const AddToBasketButton: FC<Props> = ({
  children,
  label,
  disabled = false,
  component: Component = 'button',
  conflictComponent: Conflict = AddToBasketConflict,
  conflict = false,
  loading = false,
  onClick = () => {},
  ...props
}) => {
  const { t } = useTranslation('common');
  const defaultLabel = label || t('shared.add_to_basket');
  const addToBasket = (event: SyntheticEvent) => {
    event.preventDefault();

    return Promise.resolve(onClick()).catch(() =>
      // unhappy path not catered for in this story
      // eslint-disable-next-line
      alert('Temporary popup to say there was an issue saving the booking')
    );
  };

  return conflict ? (
    <Conflict />
  ) : (
    <Component
      className="button button--secondary button--block"
      onMouseDown={(event: SyntheticEvent) => event.preventDefault()}
      {...props}
      disabled={disabled}
      onClick={addToBasket}
    >
      {loading && <Spinner className="button__spinner" />}
      {children || defaultLabel}
    </Component>
  );
};

export default AddToBasketButton;
